import React from 'react';

import { FontAwesomeIcon } from '@magoosh/lib/icons';

import { SchoolProfile, SchoolProfileCategory } from '@schools/app/types';

import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {
  currentProfile: SchoolProfile;
  isOpen: boolean;
  onTrigger: () => void;
}

const CategoryProfileListTrigger: React.FC<Props> = (props) => {
  return (
    <>
      <div
        className="d-flex"
        onClick={() => props.onTrigger()}
        style={{
          backgroundColor: props.isOpen ? colors.grayLighter : '#fff',
          borderColor: colors.grayLighter,
          borderRadius: 6,
          borderStyle: 'solid',
          borderWidth: 2,
          cursor: 'pointer'
        }}
      >
        <div
          className="visible-xs"
          style={{
            maxWidth: props.isOpen ? 0 : 150,
            overflow: 'hidden',
            // Typescript is not recognizing this property which is why we cast as 'any'
            textWrap: 'nowrap',
            transition: 'max-width 0.15s ease-out'
          } as any}
        >
          <div className="align-items-center d-flex u-padding-H-xs" style={{ height: 35 }}>
            <small>Select School</small>
          </div>
        </div>

        <div className="hidden-xs">
          <div className="align-items-center d-flex u-padding-H-xs" style={{ height: 35 }}>
            {
              props.currentProfile
                ? <small>{props.currentProfile.name}</small>
                : <small>Select School</small>
            }
          </div>
        </div>

        <div
          className="align-items-center d-flex justify-content-center"
          style={{ backgroundColor: colors.grayLighter, height: 35, width: 35 }}
        >
          <FontAwesomeIcon
            icon={props.isOpen ? 'chevron-up' : 'chevron-down'}
            style={{ color: colors.grayLight, fontSize: 12, WebkitTextStroke: `1px ${colors.grayLighter}` }}
          />
        </div>
      </div>
    </>
  );
};

export default CategoryProfileListTrigger;
